import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";

export const useSpecializationServices = ({
  enableQuery = true,
  page = "1",
  per_page = "15",
  occupation_id,
}: IGetServiceProps & { occupation_id?: string }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);

  const allSpecializationService = useQuery({
    queryKey: [
      ...CACHE_KEYS.SPECIALIZATIONS,
      page,
      debouncedQuery,
      per_page,
      occupation_id,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.SPECIALIZATIONS,
        searchParams: {
          "filter[name]": debouncedQuery,
          ...(occupation_id && { "filter[occupation_id]": occupation_id }),
          page,
          per_page,
          include: "occupation",
        },
      }),
    enabled: enableQuery,
  });
  return {
    services: { allSpecializationService },
    states: { searchQuery, setSearchQuery },
  };
};
